import {
  fetchBlog,
  fetchBlogs,
  fetchFAQS,
  fetchSeoCategory,
  fetchSeoPages,
  fetchTagsFilter,
  fetchStates,
} from '../util/api';
import { isArrayLength } from '../util/genericHelpers';
import { createImageVariantConfig } from '../util/sdkLoader';
import { parse } from '../util/urlHelpers';
import { addMarketplaceEntities } from './marketplaceData.duck';

export const FETCH_CATEGORIESS_SUCCESS = 'app/strapi/FETCH_CATEGORIESS_SUCCESS';
export const FETCH_CATEGORIESS_REQUEST = 'app/strapi/FETCH_CATEGORIESS_REQUEST';
export const SAVE_HOMEPAGE_SECTIONS = 'app/strapi/SAVE_HOMEPAGE_SECTIONS';
export const FETCH_SINGLE_CATEGORIESS_SUCCESS = 'app/strapi/FETCH_SINGLE_CATEGORIESS_SUCCESS';

export const SEARCH_BLOGS_REQUEST = 'app/strapi/SEARCH_BLOGS_REQUEST';
export const SEARCH_BLOGS_SUCCESS = 'app/strapi/SEARCH_BLOGS_SUCCESS';
export const SEARCH_BLOGS_ERROR = 'app/strapi/SEARCH_BLOGS_ERROR';
export const SEARCH_SINGLE_BLOGS_SUCCESS = 'app/strapi/SEARCH_SINGLE_BLOGS_SUCCESS';
export const SINGLE_BLOG_NOT_FOUND = 'app/strapi/SINGLE_BLOG_NOT_FOUND';
export const SINGLE_BLOG_REQUEST = 'app/strapi/SINGLE_BLOG_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/strapi/SEARCH_LISTINGS_SUCCESS';

export const SEARCH_FAQS_REQUEST = 'app/strapi/SEARCH_FAQS_REQUEST';
export const SEARCH_FAQS_SUCCESS = 'app/strapi/SEARCH_FAQS_SUCCESS';
export const SEARCH_FAQS_ERROR = 'app/strapi/SEARCH_FAQS_ERROR';
export const SEARCH_SINGLE_FAQ_SUCCESS = 'app/strapi/SEARCH_SINGLE_FAQ_SUCCESS';

export const FETCH_STATES_REQUEST = 'app/strapi/FETCH_STATES_REQUEST';
export const FETCH_STATES_SUCCESS = 'app/strapi/FETCH_STATES_SUCCESS';
export const FETCH_STATES_ERROR = 'app/strapi/FETCH_STATES_ERROR';

// ================ Reducer ================ //

const initialState = {
  seoCategories: [],
  homepageSections: [],
  seoCategory: null,
  searchInProgress: false,
  searchBlogsError: null,
  blogsData: [],
  currentPageResultIds: [],
  singleBlogData: null,
  singleBlogNotFound: false,
  faqsData: [],
  singleFaqData: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_STATES_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        fetchStatesError: null,
      };
    case FETCH_STATES_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        statesData: payload?.data?.states || [],
      };
    case FETCH_STATES_ERROR:
      return {
        ...state,
        searchInProgress: false,
        fetchStatesError: true,
      };

    case FETCH_CATEGORIESS_REQUEST:
      return {
        ...state,
        seoCategoriesInProgress: true,
        seoCategories: payload,
      };
    case FETCH_CATEGORIESS_SUCCESS:
      return {
        ...state,
        seoCategories: payload,
        seoCategoriesInProgress: false,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: payload?.data?.data?.map(l => l?.id) || [],
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case SAVE_HOMEPAGE_SECTIONS:
      return {
        ...state,
        homepageSections: payload,
      };
    case FETCH_SINGLE_CATEGORIESS_SUCCESS:
      return {
        ...state,
        seoCategory: payload,
      };
    case SEARCH_FAQS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_FAQS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        faqsData: payload?.data?.faqs || [],
      };
    case SEARCH_SINGLE_FAQ_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleFaqData: payload?.data || [],
      };
    case SEARCH_FAQS_ERROR:
      return { ...state, searchInProgress: false, searchFaqsError: true };
    case SEARCH_BLOGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        blogsData: payload?.data?.blogs || [],
        blogTags: payload?.data?.filters || [],
      };
    case SEARCH_SINGLE_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleBlogData: payload?.data || [],
        singleBlogNotFound: false,
      };
    case SINGLE_BLOG_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        singleBlogNotFound: false,
      };
    case SINGLE_BLOG_NOT_FOUND:
      return {
        ...state,
        searchInProgress: false,
        singleBlogData: null,
        // store the slug so a stale miss never 404s a different blog
        singleBlogNotFound: payload?.slug || true,
      };
    case SEARCH_BLOGS_ERROR:
      return { ...state, searchInProgress: false, searchBlogsError: true };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const fetchSeoPagesSelector = state => {
  return state.strapi.seoCategories;
};

export const fetchSeoCategoriesInProgressSelector = state => {
  return state.strapi.seoCategoriesInProgress;
};

export const getBlogsInProgress = state => state.strapi?.searchInProgress;
export const getBlogsSelector = state => state.strapi?.blogsData;
export const getBlogsTagsSelector = state => state.strapi?.blogTags;

export const getBlogSelector = state => state.strapi.singleBlogData;
export const getBlogNotFoundSelector = state => state.strapi?.singleBlogNotFound || false;
export const getSeoCategory = state => state.strapi.seoCategory;
export const getSeoListings = state => state.strapi.currentPageResultIds;

export const getFaqsInProgress = state => state.strapi?.searchInProgress;
export const getFaqsSelector = state => state.strapi?.faqsData;
export const getFaqSelector = state => state.strapi.singleFaqData;

export const getStatesData = state => {
  const { searchInProgress, statesData, fetchStatesError } = state.strapi || {};
  return { searchInProgress, statesData, fetchStatesError };
};

// ================ Action creators ================ //

export const fetchStatesRequest = () => ({
  type: FETCH_STATES_REQUEST,
});

export const fetchStatesSuccess = response => ({
  type: FETCH_STATES_SUCCESS,
  payload: { data: response },
});

export const fetchStatesError = () => ({
  type: FETCH_STATES_ERROR,
});

export const searchFaqsRequest = () => ({
  type: SEARCH_FAQS_REQUEST,
});

export const searchFaqsSuccess = response => ({
  type: SEARCH_FAQS_SUCCESS,
  payload: { data: response },
});

export const searchSingleFaqSuccess = response => ({
  type: SEARCH_SINGLE_FAQ_SUCCESS,
  payload: { data: response },
});

export const searchFaqsError = () => ({
  type: SEARCH_FAQS_ERROR,
});

export const fetchSingleSeoCategorySuccess = payload => ({
  type: FETCH_SINGLE_CATEGORIESS_SUCCESS,
  payload,
});

export const fetchSeoCategoriesRequest = payload => ({
  type: FETCH_CATEGORIESS_REQUEST,
  payload,
});

export const fetchSeoCategoriesSuccess = payload => ({
  type: FETCH_CATEGORIESS_SUCCESS,
  payload,
});

export const saveHomepageSections = payload => ({
  type: SAVE_HOMEPAGE_SECTIONS,
  payload,
});

export const searchBlogsRequest = () => ({
  type: SEARCH_BLOGS_REQUEST,
});

export const searchBlogsSuccess = response => ({
  type: SEARCH_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchSingleBlogsSuccess = response => ({
  type: SEARCH_SINGLE_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchBlogsError = () => ({
  type: SEARCH_BLOGS_ERROR,
});

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

// ================ Thunks ================ //

export const fetchSeoCategoryBySlug = params => async (dispatch, getState, sdk) => {
  const { config, ...rest } = params;
  try {
    const { category } = (await fetchSeoCategory({ ...rest })) || {};

    if (isArrayLength(category) && category[0]) {
      // Save the Strapi category to the store FIRST. This guarantees the local
      // SEO content (title, meta, htmlDescription, body) renders server-side
      // even if the Sharetribe listings query below fails or times out during
      // SSR. Previously a listings-query failure threw and discarded the whole
      // category (empty page + empty <title> for crawlers).
      dispatch(fetchSingleSeoCategorySuccess(category[0]));

      // The Strapi category `url` field is a saved map-search link of the form
      // `s?address=Austin%2C%20TX%2C%20USA&bounds=lat,lng,lat,lng&mapSearch=true`.
      // Two things must happen for the Sharetribe listings query to work:
      //   1. Strip everything up to and including the first `?`. The leading
      //      `s?` path otherwise makes queryString.parse key the first param
      //      as `s?address` instead of `address`.
      //   2. Pass `{ latlngBounds: ['bounds'] }` so `parse` decodes the bounds
      //      comma-string into an SDKTypes.LatLngBounds instance. Without this
      //      option `bounds` stays a raw string, which the SDK rejects, so the
      //      query silently returns 0 listings. This mirrors how SearchPage
      //      parses its search string (SearchPage.duck.js / .shared.js).
      const url = category[0]?.url;
      const searchStr = url && url.includes('?') ? url.slice(url.indexOf('?') + 1) : url;
      const parsedURL = parse(searchStr, { latlngBounds: ['bounds'] });

      // Listings are a nice-to-have enhancement (crawlable internal links). If
      // the Sharetribe query fails/times out during SSR, we still keep the
      // Strapi content dispatched above rather than blanking the page.
      try {
      const response = await sdk.listings.query({
        bounds: parsedURL?.bounds,
        pub_isInfoOnly: false, // Query all bookable listings
        include: ['author', 'images'],
        'fields.listing': [
          'title',
          'geolocation',
          'price',
          'publicData.listingType',
          'publicData.transactionProcessAlias',
          'publicData.unitType',
          // These help rendering of 'purchase' listings,
          // when transitioning from search page to listing page
          'publicData.pickupEnabled',
          'publicData.shippingEnabled',
        ],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
        'fields.image': [
          'variants.scaled-small',
          'variants.scaled-medium',
          `variants.listing-card`,
          `variants.listing-card-2x`,
        ],
        ...createImageVariantConfig(`listing-card`, 400, 1),
        ...createImageVariantConfig(`listing-card-2x`, 800, 1),
        'limit.images': 1,
      });
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(searchListingsSuccess(response));
      return response;
      } catch (listingsError) {
        console.log(listingsError, 'Error while fetching SEO category listings (content preserved)');
        return null;
      }
    }
    return null;
  } catch (error) {
    console.log(error, 'Error while fetching seo category');
    return null;
  }
};

// SSR loadData for SeoCategoryPage (city pages: /states/:state/:title).
// Runs on the server before render so listings + local Strapi content are
// present in the initial HTML (fixes Googlebot seeing an empty shell).
export const loadData = (params, search, config) => dispatch => {
  const title = params?.title || '';
  // Fetch the city category + listings first (critical path), then hydrate the
  // interlinking data (all city categories + states + blogs) so the city
  // internal-link block (nearby cities + state guide + breadcrumb) is present
  // in the server-rendered HTML. Best-effort: a failure must never blank the
  // page.
  return dispatch(fetchSeoCategoryBySlug({ title, config })).then(catResp => {
    const interlinkPromises = [
      dispatch(fetchSeoCategories({})).catch(e => {
        console.log('City interlink: fetchSeoCategories failed', e && e.message);
      }),
      dispatch(fetchAllStates({})).catch(e => {
        console.log('City interlink: fetchAllStates failed', e && e.message);
      }),
      dispatch(fetchAllBlogs({})).catch(e => {
        console.log('City interlink: fetchAllBlogs failed', e && e.message);
      }),
    ];
    return Promise.all(interlinkPromises).then(() => catResp);
  });
};

// SSR loadData for SingleBlogPage (/blog/:title). Fetches the Strapi blog
// server-side so the article renders in the initial HTML for crawlers
// (fixes Googlebot seeing "Blog not found").
// SSR loader for the /blog index (and /blog/page/:page). Fetches all blogs +
// tags server-side so the post grid, category tabs, and pagination links are
// present in the server-rendered HTML (crawlable by Google). Best-effort: a
// failure must never blank the page.
export const loadBlogListData = (params, search, config) => dispatch => {
  return dispatch(fetchAllBlogs({})).catch(e => {
    console.log('BlogList SSR: fetchAllBlogs failed', e && e.message);
  });
};

export const loadBlogData = (params, search, config) => dispatch => {
  const slug = params?.title;
  if (!slug) return Promise.resolve();
  // Fetch the blog first (critical path), then hydrate the interlinking data
  // (states + all city categories + blog list) so the SEO internal-link block
  // is present in the server-rendered HTML (crawlable by Google). Interlink
  // fetches are best-effort: a failure must never blank the blog page.
  return dispatch(fetchSingleBlog({ slug })).then(blogResp => {
    const interlinkPromises = [
      dispatch(fetchAllStates({})).catch(e => {
        console.log('Interlink: fetchAllStates failed', e && e.message);
      }),
      dispatch(fetchSeoCategories({})).catch(e => {
        console.log('Interlink: fetchSeoCategories failed', e && e.message);
      }),
      dispatch(fetchAllBlogs({})).catch(e => {
        console.log('Interlink: fetchAllBlogs failed', e && e.message);
      }),
    ];
    return Promise.all(interlinkPromises).then(() => blogResp);
  });
};

export const fetchSeoCategories = params => async (dispatch, getState, sdk) => {
  dispatch(fetchSeoCategoriesRequest());
  try {
    const { categories = {} } = (await fetchSeoPages({ ...params })) || {};
    const filteredCategories = isArrayLength(categories)
      ? categories.filter((v, i, a) => a?.findIndex(v2 => v2?.id === v?.id) === i)
      : [];
    dispatch(fetchSeoCategoriesSuccess(filteredCategories));
    return filteredCategories;
  } catch (error) {
    console.log(error, 'Error while fetching seo categories');
    return null;
  }
};

// SSR loadData for StateListsPage (/states/:state) - list of a state's cities.
// Also hydrates the states list + blogs (best-effort) so the state-page
// interlink block (this state's towing-laws guide + other-states cross-links)
// renders in the server HTML. A failure must never blank the page.
export const loadStateData = (params, search, config) => dispatch => {
  const state = params?.state;
  return dispatch(fetchSeoCategories({ state })).then(catsResp => {
    const interlinkPromises = [
      dispatch(fetchAllStates({})).catch(e => {
        console.log('State interlink: fetchAllStates failed', e && e.message);
      }),
      dispatch(fetchAllBlogs({})).catch(e => {
        console.log('State interlink: fetchAllBlogs failed', e && e.message);
      }),
    ];
    return Promise.all(interlinkPromises).then(() => catsResp);
  });
};

export const fetchSingleBlog = params => async (dispatch, getState, sdk) => {
  dispatch({ type: SINGLE_BLOG_REQUEST });
  try {
    const response = await fetchBlog({ ...params });
    if (response?.notFound || !response?.blog) {
      dispatch({ type: SINGLE_BLOG_NOT_FOUND, payload: { slug: params?.slug } });
      return response;
    }
    dispatch(searchSingleBlogsSuccess(response?.blog));
    return response;
  } catch (error) {
    dispatch(searchBlogsError());
    console.log(error, 'Error while fetching seo categories');
  }
};

export const fetchAllStates = params => async (dispatch, getState, sdk) => {
  dispatch(fetchStatesRequest());
  try {
    const response = await fetchStates({ ...params });
    dispatch(fetchStatesSuccess({ states: response?.states }));
    return response;
  } catch (error) {
    dispatch(fetchStatesError());
    console.log(error, 'Error while fetching states');
  }
};

export const fetchAllBlogs = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());

  try {
    let blogsResponse, tagsResponse;

    // Fetch blogs
    blogsResponse = await fetchBlogs({ ...params });
    tagsResponse = await fetchTagsFilter({});

    dispatch(
      searchBlogsSuccess({
        blogs: blogsResponse?.blogs,
        filters: tagsResponse ? tagsResponse?.tags : [],
      })
    );
    return blogsResponse?.blogs;
  } catch (error) {
    dispatch(searchBlogsError());
  }
};

// SSR loadData for FAQPage (/faq). Server-renders the FAQ Q&A + FAQPage JSON-LD
// so Google can crawl the answers and show the rich-result. Without this the
// FAQ was client-fetch-only (invisible to crawlers).
export const faqLoadData = (params, search, config) => dispatch => {
  return dispatch(fetchAllFaqs({}));
};

export const fetchAllFaqs = params => async (dispatch, getState, sdk) => {
  dispatch(searchFaqsRequest());

  try {
    let faqsResponse;

    // Fetch all FAQs
    faqsResponse = await fetchFAQS({ ...params });

    dispatch(
      searchFaqsSuccess({
        faqs: faqsResponse?.faqs,
      })
    );
    return faqsResponse?.faqs;
  } catch (error) {
    dispatch(searchFaqsError());
  }
};
// -----------------------------------------------
// Fetch SEO-friendly listings (server-rendered crawlable data)
// -----------------------------------------------
export const fetchSeoListingsForCity = params => async (dispatch, getState, sdk) => {
  try {
    // Calls your backend endpoint: /api/strapi/fetchSeoListings
    const response = await sdk.apiClient.post("/api/strapi/fetchSeoListings", params);

    // Return the listings for immediate use (we're not storing them in Redux)
    return response?.data?.listings || [];
  } catch (err) {
    console.error("Error fetching SEO listings:", err);
    return [];
  }
};
